import React from "react";
import Box from "@mui/material/Box";
import { LinearProgress } from "@mui/material";
import { useSelector } from "react-redux";

const LinearLoading = () => {
  const teacherLoading = useSelector((state) => state.teacherReducer.loading);
  const authLoading = useSelector((state) => state.authReducer.loading);
  const adminLoading = useSelector((state) => state.adminReducer.loading);

  return (
    <>
      {(teacherLoading || authLoading || adminLoading) && (
        <Box sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
      )}
    </>
  );
};

export default LinearLoading;
